<template>
    <div id="products-container" class="block-type-container" name="luts-you-own-container">
        <span class="type-title">Lutify.me LUTs</span>

        <span class="type-subtitle mt-2">LUTs you own</span>
        <div class="control-name" style="grid-template-columns: 1fr; width: 100%">
            <div class="control-label d-flex align-center justify-space-between">
                <span @click="addBlock(controlFreeLuts)" style="width: 100%">{{ controlFreeLuts.name }}</span>
                <span v-if="isCurrentPlanFree" @click="downloadFreeLutsPackage" v-tippy content="Download Free LUT Pack" class="material-symbols-outlined" style="font-size: 18px; margin-right: 1px">download</span>
            </div>
        </div>

        <div v-for="product in purchasedProductsList" :key="product.fs_slug" @click="select(product)" class="control-name" style="grid-template-columns: 1fr; width: 100%" data-name="product-block">
            <div class="control-label d-flex align-center justify-space-between">
                <span>{{ product.name }}</span>
                <span v-tippy='{ interactive : true, delay: [0, 0], theme: "info" }' :content="productDescription(product)" class="material-symbols-outlined"
                      :name="product.fs_slug">info</span>
            </div>
        </div>

        <div class="separator"></div>

        <span class="type-subtitle mt-5">LUTs available for purchase</span>
        <div v-for="product in productsToPurchase" :key="product.fs_slug" @click="select(product)" class="control-name" data-name="product-block">
                <div class="control-label d-flex align-center justify-space-between">
                    <span v-if="product.fs_slug == 'lut-pack-bundle'" class="d-flex align-center">{{ product.name }} <span class="control-label--new ml-3">BEST VALUE</span></span>
                    <span v-else>{{ product.name }}</span>
                    <span v-tippy='{ interactive : true, delay: [0, 0], theme: "info" }' :content="productDescription(product)" class=" material-symbols-outlined"
                          :name="product.fs_slug">info</span>
                </div>
                <span class="icon-lock material-symbols-outlined">lock</span>
        </div>
        <span v-if="productsToPurchase.length == 0" class="mt-1" style="padding: 0 4px; line-height: 1.3">No additional LUT packs available for purchase at this moment</span>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import download from 'downloadjs';

export default {
    data() {
        return {
            controlFreeLuts: {
                name: "Free LUTs",
                category: "LUTcontrols",
                label: "Free LUTs",
                LUTbased: true,
            }
        }
    },

    async mounted() {
        await this.$store.dispatch("Products/fetch");

        if (!localStorage.getItem('selected_product')) return;
        if (localStorage.getItem('selected_product') == "lite") {
            localStorage.removeItem('selected_product');
            this.$router.push({ name: "account.billing.changePlan" });
            return;
        }

        if (!this.$store.state.Products.products.find(product => product.fs_slug == localStorage.getItem('selected_product'))) return;

        let product = this.$store.state.Products.products.find(product => product.fs_slug == localStorage.getItem('selected_product'));
        const interval = setInterval(() => {
            if (!window.UI) return;
            clearInterval(interval)
            this.select(product)
        }, 100)
    },

    computed: {
        ...mapState("UI", ["startTipsStep"]),
        ...mapState("Products", ["products"]),
        ...mapState("Projects", ["image"]),
        ...mapState("User", ["user", "account"]),
        ...mapState("Plans", ['PLAN_LITE_FREE', 'PLAN_LITE']),
        ...mapGetters("Organizations", ["isProductPurchased"]),
        ...mapGetters("User", ["isCurrentPlanFree"]),
        purchasedProductsList() {
            return this.products.filter(product => {
                if (!this.isProductPurchased(product.id)) return false;
                if (product.fs_slug == 'lut-pack-bundle' && this.isProductPurchased(product.id)) return false;
                return product;
            })
        },

        productsToPurchase() {
            return this.products.filter(product => {
                if (!this.isProductPurchased(product.id)) return product;
                // if (product.fs_slug !== 'lut-pack-bundle' || (product.fs_slug == 'lut-pack-bundle' && !this.isProductPurchased(product.id))) return product;
            })
        }
    },

    methods: {
        async downloadFreeLutsPackage() {
            await this.$store.dispatch("Loader/showProgressBar", "indeterminate");
            const response = await this.$store.dispatch('Files/downloadFreeLutsPackage');
            this.$store.dispatch("Loader/showProgressBar", false);
            download(response.url)
        },

        select(product) {
            if (this.isProductPurchased(product.id)) {
                if (this.account.plan_id == this.PLAN_LITE_FREE.id) {
                    this.$router.push({name: "account.billing.changePlan"});
                } else if (this.image) {
                    this.addBlock(product);
                }
            } else {
                this.$store.commit('Products/SET_SELECTED_PRODUCT', product);
                window.UI.showModal(UI.modals.products.purchase);
            }
        },

        productDescription(product) {
            return `
                <div style="display: flex !important; flex-direction: column; gap: 20px;">
                    <span class="d-block" style="text-align: left; line-height: 1.2">${product.description}</span>
                    <a href="${product.link}" target="_blank" class="d-block" style="color: white">Learn more</a>
                </div>
            `
        },

        async addBlock(product) {
            if (this.$store.state.App.blockLoading) return;

            this.$store.dispatch('UI/setLeftColumn', 'appliedBlocks');

            let data = {
                control: "LUTcontrols",
                category: product.name,
                initial: true,
            };

            if (product !== this.controlFreeLuts) data.product = product;

            await _Adjustments[data.control].addBlock(blocks.getNewBlockNumber(), data);

            UI.toggleStartTips();

            lutify.storeLastState();

            if (lutify.activeSidebarContainer !== "blocks") {
                this.$store.dispatch('UI/setLeftColumn', 'appliedBlocks')
                UI.scrollToBlock(lutify.activeBlock);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#products-container {
    grid-template-rows: initial !important;
}

.separator {
    height: 1px;
    background: var(--dark-gray);
    margin: 30px 0 20px;
}
</style>